import { render, staticRenderFns } from "./PlayersTableHeadCell.vue?vue&type=template&id=8843b934&"
import script from "./PlayersTableHeadCell.vue?vue&type=script&lang=js&"
export * from "./PlayersTableHeadCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports